export default "__VITE_ASSET__DrUS8SDp__"